// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7529f4b7","453":"95645ffc","806":"9bf99f8b"}[chunkId] + ".chunk.js";
};